import { render, staticRenderFns } from "./AddTagGroup.vue?vue&type=template&id=5bc9f492"
import script from "./AddTagGroup.vue?vue&type=script&lang=js"
export * from "./AddTagGroup.vue?vue&type=script&lang=js"
import style0 from "./AddTagGroup.vue?vue&type=style&index=0&id=5bc9f492&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports